<template lang="pug">
  .form
    achievement-modal(
      v-if="showAchievementModal"
      :default-award="defaultAward"
      :title="achievementModalTitle"
      @close="onCloseAchievementModal()"
      @onAddAward="addAward"
    )
    .form__elem
      .form-elem.form-elem_horizontal
        .form-elem__title Копия документов
        .form-elem__body
          .achievements
            .achievements__list.achievements-list
              .achievements-list__item(
                v-for="award in localAwards"
              )
                .achievement
                  .attached-file
                    .button
                      .button__text(@click="onUpdateAward(award)") {{ award.name }}
                      .attached-file__button-remove(
                        @click="deleteAward(award)"
                      )
                        img(src="@/assets/images/icons/grey-cross.svg")
            .achievements__button-add
              button.button(
                type="button"
                @click.prevent="showAchievementModal = true"
              )
                .button__icon
                  img(src="@/assets/images/icons/clip.svg")
                .button__text Добавить документ
          .form-elem__description Здесь вы можете прикрепить копию сертификатов, грамот, благодарностей за участие в соревнованиях, конкурсах, олимпиадах вашего ребенка или  копию обращения образовательной организации . Формат файла - jpeg, размер не должен превышать 1 Мб.
          //- &#160;1мб.
    .form__elem
      .form-elem.form-elem_horizontal
        .form-elem__title Количество баллов
        .form-elem__body
          .points {{ getPoints(localAwards) }}
          .form-elem__description Баллы насчитываются на основе уровня достижений. Чем выше достижения, тем больше баллов.
</template>
<script>
//todo переделать список на .f-list и .attached-item
import AttachFile from "@/components/attach-file/AttachFile";
import AchievementModal from "@/components/modals/AchievementModal";
export default {
  name: "FormPortfolio",
  components: {
    AttachFile,
    AchievementModal
  },
  props: {
    awards: {
      type: Array,
      default: () => []
    },
    keymonitor: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      showAchievementModal: false,
      defaultAward: {},
      achievementModalTitle: "Добавить достижение"
    };
  },
  computed: {
    localAwards: {
      get() {
        return this.awards;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "awards"]);
      }
    }
  },
  methods: {
    onUpdateAward(award) {
      this.defaultAward = JSON.parse(JSON.stringify(award));
      this.showAchievementModal = true;
    },
    deleteAward(award) {
      this.localAwards = this.localAwards.filter(el => el.id !== award.id);
    },
    addAward(award) {
      const localAward = this.localAwards.find(el => el.id === award.id);
      if (localAward) {
        this.localAwards = this.localAwards.map(el => {
          if (el.id === award.id) {
            el = award;
          }
          return el;
        });
      } else {
        this.localAwards.push(award);
      }
    },
    onCloseAchievementModal() {
      this.showAchievementModal = false;
      this.defaultAward = {};
    },
    getPoints(list) {
      var points = 0;
      for (var i = 0; i < list.length; i++) {
        points += list[i].points;
      }
      return points;
    }
  }
};
</script>
